import { render, staticRenderFns } from "./templates.vue.html?vue&type=template&id=6c8ec62d"
import script from "./templates.controller?vue&type=script&lang=js&external"
export * from "./templates.controller?vue&type=script&lang=js&external"
import style0 from "./templates.vue.html?vue&type=style&index=0&id=6c8ec62d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports